var fn_search_nav = function () {

    // popover footer
    var search_button = $('.nav-item-button-search');
    var search_button_txt = $('.nav-item-button-search span + span');
    var search_wrapper = $('.nav-item-block-search');

    search_button.on('click', function () {
        if( $(this).hasClass('open') ) {
            $(this).removeClass('open').attr('aria-expanded', 'false');
            search_button_txt.html('Ouvrir la recherche');
            search_wrapper.removeClass('show').attr('aria-hidden', 'true');
        } else {
            $(this).addClass('open').attr('aria-expanded', 'true');
            search_button_txt.html('Fermer la recherche');
            search_wrapper.addClass('show').attr('aria-hidden', 'false');            
        }
    });

    // > 1200px
	Harvey.attach('screen and (min-width:75em)', {
		on: function () {
            search_button.removeClass('d-none');
            search_wrapper.removeClass('show').attr('aria-labelledby','search-content').attr('aria-hidden', 'true');
		}
	});
    
	// < 1199px
	Harvey.attach('screen and (max-width:74.9375em)', {
        on: function () {
            search_button.addClass('d-none');
            search_wrapper.addClass('show').removeAttr('aria-labelledby').attr('aria-hidden', 'false');
		}
	});

}